// extracted by mini-css-extract-plugin
export default {"pageWrap":"Db-z","fullWidth":"Eb-z","heading":"Fb-z","fullBleed":"Gb-z","hidden":"Hb-z"};